import  Gateway     from '@nsftx/seven-gravity-gateway/slave';
import {EventBus}   from '../utilities/event.bus';
import {TicketSvc}  from '../services/ticket.service';
import {BettingSvc} from '../services/betting.service';
import {GameSvc}    from '../services/game.service';
import {RulesSvc}   from '../services/rules.service';
import {ConfigurationSvc}  from '../services/configuration.service';
import {TranslationSvc}  from '../services/translation.service';
import {formatter}  from '../utilities/ticketFormatter';
import {printFormatter}  from '../utilities/printFormatter';
import storage from '../utilities/localStorage';
import Retail from '@nsftx/seven-gravity-gateway/plugin-retail';

TicketSvc.init();
ConfigurationSvc.init();
BettingSvc.init();

let ticketSvc = TicketSvc.getTicketSvc();
let bettingSvc = BettingSvc.getBettingSvc();

class GatewaySvc {
    /**
     * Initialize gateway communication
     */
    initialize() {
      // const pathName = window.location.pathname.split('/')[1].split('?')[0];
      // const slaveId = pathName === 'ticketHistory' ? 'KenoTicketHistory' : 'Keno';

        this.gateway =  Gateway({
          slaveId: 'Keno',
          load(message) {
            window.sevenConfig = message;
            ConfigurationSvc.getConfigurationSvc().get(() => {
                TranslationSvc.getTranslations();
                EventBus.$on('SendSlaveLoaded', () => {
                    this.sendMessage({
                        action: 'Slave.Loaded',
                        data: {
                          tax: sevenConfig.data.config.taxes
                        }
                      });
                })
                EventBus.$emit('Keno.ConfigLoaded');
            });
          },
          eventListeners: {
            'keydown': [ '9', '13', '70', '82', '83', '87', '107', '111', '187']
          },
          eventPropagation: {
            click: true,
            'keydown' : '*'
          },
          plugins: [ new Retail() ],
          allowedOrigins : '*',
          debug:true
        });

      this._subscribeToCommonEvents();
      this._subscribeToBetslipEvents();
      this._subscribeToGameEvents();
      this._subscribeToTicketEvents();
      this._subscribeToUIEvents();
    }

    _subscribeToCommonEvents() {
      this.gateway.subscribe('User.AuthorizationChanged', message => {
        EventBus.$emit(message.action, message);

        window.sevenConfig.data.user.auth.token = message.data.token;
      })
    }

    _subscribeToUIEvents() {
      this.gateway.subscribe('UI.Show', message => {
        EventBus.$emit(message.action, message);
      });
    }

    /**
     * Subscribe to betslip events
     * @private
     */
    _subscribeToBetslipEvents() {
        this.gateway.subscribe('Betslip.BetSelected', message => {
            EventBus.$emit(message.action, {
                bet: message.data.bet,
                ticket: message.data.ticket
            });
        });

        this.gateway.subscribe('Betslip.SelectedBetUpdated', message => {
            EventBus.$emit('Shop.Clear');
            ticketSvc.ticket = message.data.ticket;
        });

        this.gateway.subscribe('Betslip.Payin', message => {
            ticketSvc.resetTicket();

            if (RulesSvc.getRulesSvc().validateBetslip(message.data.ticket)) {
                //avoid master betslip validation
                message.data.validateTicket = false;
                message.data.hasOwnTicket = true;
                message.data.ticketFormatted = formatter(message.data);

                var showWarningModal = false;

                if (GameSvc.getGameSvc().gameInfo.betsBlocked) {
                    this.showDialog({
                        message: TranslationSvc.getTranslation('games.betting_disabled_short'),
                        type: 'info',
                        delay: 1500,
                        focus: false
                    })
                    return;
                }

                for (let i = 0; i<message.data.ticket.bets.length; ++i) {
                    if (message.data.ticket.bets[i].updatedWithNewRound) {
                        showWarningModal = true;
                        break;
                    }
                }

                if (showWarningModal) {
                    GameSvc.gameSvc.showTicketUpdatedWarningModal();
                    bettingSvc.storedMessage = message;
                    return;
                }

                this.payIn(message);
            }
        });

        this.gateway.subscribe('Betslip.Reset', message => {
            ticketSvc.ticket = '';
            bettingSvc.clearAll();
            bettingSvc.clearUpdateBetStatus();
            EventBus.$emit("Keno.ClearSpecialBettings");
            EventBus.$emit('keydown',{
                key : '+'
            });
        });

        this.gateway.subscribe('Betslip.BetAdded', message => {
            ticketSvc.ticket = message.data.ticket;
        });

        this.gateway.subscribe('Betslip.BetRemoved', message => {
            ticketSvc.ticket = message.data.ticket;

            bettingSvc.clearAll();
            bettingSvc.clearUpdateBetStatus();
            EventBus.$emit("Keno.ClearSpecialBettings");
            EventBus.$emit('keydown',{
                key : '+'
            });
        });

        this.gateway.subscribe('Betslip.MaxStake', (payload) => {
            const ticket = ticketSvc.ticket,
                totalBets = ticket.bets ? ticket.bets.length : 0,
                stake = GameSvc.getGameSvc().rules.maxBetAmount.value,
                maxStake = totalBets ? totalBets * stake : stake;
            
            const balance = payload.data.balance;


            this.sendMessage('Betslip.UpdateMeta', {
                stake: maxStake > balance ? balance : maxStake,
            });
        });

        this.gateway.subscribe('Betslip.TicketStateChanged', message => {
            ticketSvc.ticket = message.data.ticket;
        });
    }

    /**
     * Subscribe to ticket events
     * @private
     */
    _subscribeToTicketEvents(){
        this.gateway.subscribe('Tickets.ReBet', message => {
            EventBus.$emit(message.action, {
                reference: message.data.reference,
                ticket: message.data.ticket
            });
        });

        this.gateway.subscribe('Tickets.PrePrint', message => {
            EventBus.$emit(message.action, {
                reference: message.data.reference,
                language: message.data.language
            });

            const data = message.data;
            data.responseData = printFormatter(data.responseData);

            this.sendMessage('Tickets.Print', data);
            ticketSvc.resetTicket();
        });

        this.gateway.subscribe('Tickets.GetActions', event => {
            event.resolve({
              actions: {
                rebet: {
                  active: true
                },
                check: {
                  active: true
                },
                copy: {
                  active: true
                }
            }})
          });

        this.gateway.subscribe('Tickets.FetchHistory', message => {
          EventBus.$emit(message.action, message);
        });
    }

    /**
     * Subscribe to ticket events
     * @private
     */
    _subscribeToGameEvents() {
        this.gateway.subscribe('Master.Event', message => {
            if(message.event === 'keydown'){
                EventBus.$emit('keydown', {
                    key: message.key
                });
            }
        });

        this.gateway.subscribe('Widget.Event', message => {
            if (message.data.type === 'DialogAction') {

                let id = '';
                const bettingSvc =  BettingSvc.getBettingSvc();

                if (sevenConfig.data.dp.toLowerCase() === 'terminal' ||
                    sevenConfig.data.dp.toLowerCase() === 'retail') {
                    id = message.data.notification.config.id;
                }

                if (id === 'payinModal') {

                    if (message.data.action.key === '1' && bettingSvc.storedMessage !== null) {
                        this.payIn(bettingSvc.storedMessage);
                        bettingSvc.storedMessage = null;
                    } else {
                        // clears the betslip
                        EventBus.$emit('keydown',{
                            key : "/"
                        });
                    }
                }
            }

            if(message.data.event === 'click'){
                //todo - change event name
                EventBus.$emit('keydown',{
                    key : message.data.shortcut
                });
            }
        });

        this.gateway.subscribe('Slave.Shown', () => {
            storage.saveKey('isGameActive', true);
            bettingSvc.clearAll(true);
            EventBus.$emit('Slave.Shown');

            this.sendMessage('Betslip.ActivateTicket', {
                betslipId: 'Keno',
                ticketId: 'single'
            });

            EventBus.$emit('keydown',{
                key : '+'
            });
        });
    }

    payIn(message) {
        let valid = RulesSvc.getRulesSvc().validateBetslip(message.data.ticket);
        if(valid) {
            //avoid master betslip validation
            message.data.validateTicket = false;
            message.data.hasOwnTicket = true;
            message.data.ticketFormatted = formatter(message.data);

            this.sendMessage('Ticket:Payin.Send', message.data);

            //set focus on first input
            EventBus.$emit('keydown',{
                key : '+'
            });
        }
    }

    /**
     * Display popup dialog
     * @param {String} data.id
     * @param {String} data.message
     * @param {Number} data.delay - Message duration in miliseconds
     * @param {String} data.type - Message type - info, warning or error
     * @param {Function} data.actions - Actions to take
     * @param {Boolean} data.showDefaultAction - Default actions
     * @param {Boolean} data.focus - Set focus on Message dialog
     */
    showDialog(data) {
        const dataObj = {
            id: data.id || 'Keno',
            message: data.message || '',
            type: data.type || 'info',
            delay: data.hasOwnProperty('delay') ? data.delay : bettingSvc.notificationDelay,
            showDefaultAction: data.showDefaultAction || false,
            focus: data.focus || false,
            actions: data.actions || []
        };

        this.sendMessage('Dialog.Close', {});
        this.sendMessage('Dialog.Show', dataObj);
    }

    /**
     * Send message to master
     * @param {String} action
     * @param {Object} data
     */
    sendMessage(action,data){
        let enforcedEvents = [
            'Tickets.Print',
            'Widget.UpdateProductSettings',
            'Ticket:Payin.Send',
            'ticket:payoutResponse',
            'ticket:cancelResponse'
        ];

        this.gateway.sendMessage({
            action: action,
            data: data,
            enforceEvent: enforcedEvents.indexOf(action) > -1
        });
    }
}

export default GatewaySvc;



// WEBPACK FOOTER //
// gateway.js